import { render, staticRenderFns } from "./HeatCapability.vue?vue&type=template&id=f235faae&scoped=true&"
import script from "./HeatCapability.vue?vue&type=script&lang=js&"
export * from "./HeatCapability.vue?vue&type=script&lang=js&"
import style0 from "./HeatCapability.vue?vue&type=style&index=0&id=f235faae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f235faae",
  null
  
)

export default component.exports